export const nfcTagTypes = {
  GET_NFC_TAGS: "GET_NFC_TAGS",
  GET_NFC_TAGS_STATUS: "GET_NFC_TAGS_STATUS",
  ADD_NFC_TAG: "ADD_NFC_TAG",
  EDIT_NFC_TAG: "EDIT_NFC_TAG",
  DELETE_NFC_TAG: "DELETE_NFC_TAG",
  UPDATE_NFC_TAG_STATUS: "UPDATE_NFC_TAG_STATUS",
};